type DfesRegion = {
  originalDfesRegion: string;
  dfesRegionDisplayName: string;
  lgas: Lga[];
};

type Lga = {
  name: string;
  longName: string;
  displayName: string;
};

export const regionsLgasMapping: DfesRegion[] = [
  {
    originalDfesRegion: 'GOLDFIELDS/MIDLANDS',
    dfesRegionDisplayName: 'Goldfields Midlands',
    lgas: [
      { name: 'KALGOORLIE-BOULDER', longName: 'KALGOORLIE-BOULDER, CITY OF', displayName: 'City of Kalgoorlie-Boulder' },
      { name: 'BEVERLEY', longName: 'BEVERLEY, SHIRE OF', displayName: 'Shire of Beverley' },
      { name: 'BRUCE ROCK', longName: 'BRUCE ROCK, SHIRE OF', displayName: 'Shire of Bruce Rock' },
      { name: 'COOLGARDIE', longName: 'COOLGARDIE, SHIRE OF', displayName: 'Shire of Coolgardie' },
      { name: 'CUNDERDIN', longName: 'CUNDERDIN, SHIRE OF', displayName: 'Shire of Cunderdin' },
      { name: 'DALWALLINU', longName: 'DALWALLINU, SHIRE OF', displayName: 'Shire of Dalwallinu' },
      { name: 'DOWERIN', longName: 'DOWERIN, SHIRE OF', displayName: 'Shire of Dowerin' },
      { name: 'DUNDAS', longName: 'DUNDAS, SHIRE OF', displayName: 'Shire of Dundas' },
      { name: 'GOOMALLING', longName: 'GOOMALLING, SHIRE OF', displayName: 'Shire of Goomalling' },
      { name: 'KELLERBERRIN', longName: 'KELLERBERRIN, SHIRE OF', displayName: 'Shire of Kellerberrin' },
      { name: 'KOORDA', longName: 'KOORDA, SHIRE OF', displayName: 'Shire of Koorda' },
      { name: 'LAVERTON', longName: 'LAVERTON, SHIRE OF', displayName: 'Shire of Laverton' },
      { name: 'LEONORA', longName: 'LEONORA, SHIRE OF', displayName: 'Shire of Leonora' },
      { name: 'MENZIES', longName: 'MENZIES, SHIRE OF', displayName: 'Shire of Menzies' },
      { name: 'MERREDIN', longName: 'MERREDIN, SHIRE OF', displayName: 'Shire of Merredin' },
      { name: 'MOUNT MARSHALL', longName: 'MOUNT MARSHALL, SHIRE OF', displayName: 'Shire of Mount Marshall' },
      { name: 'MUKINBUDIN', longName: 'MUKINBUDIN, SHIRE OF', displayName: 'Shire of Mukinbudin' },
      { name: 'NAREMBEEN', longName: 'NAREMBEEN, SHIRE OF', displayName: 'Shire of Narembeen' },
      { name: 'NGAANYATJARRAKU', longName: 'NGAANYATJARRAKU, SHIRE OF', displayName: 'Shire of Ngaanyatjarraku' },
      { name: 'NORTHAM', longName: 'NORTHAM, SHIRE OF', displayName: 'Shire of Northam' },
      { name: 'NUNGARIN', longName: 'NUNGARIN, SHIRE OF', displayName: 'Shire of Nungarin' },
      { name: 'QUAIRADING', longName: 'QUAIRADING, SHIRE OF', displayName: 'Shire of Quairading' },
      { name: 'TAMMIN', longName: 'TAMMIN, SHIRE OF', displayName: 'Shire of Tammin' },
      { name: 'TOODYAY', longName: 'TOODYAY, SHIRE OF', displayName: 'Shire of Toodyay' },
      { name: 'TRAYNING', longName: 'TRAYNING, SHIRE OF', displayName: 'Shire of Trayning' },
      { name: 'WESTONIA', longName: 'WESTONIA, SHIRE OF', displayName: 'Shire of Westonia' },
      { name: 'WONGAN-BALLIDU', longName: 'WONGAN-BALLIDU, SHIRE OF', displayName: 'Shire of Wongan-Ballidu' },
      { name: 'WYALKATCHEM', longName: 'WYALKATCHEM, SHIRE OF', displayName: 'Shire of Wyalkatchem' },
      { name: 'YILGARN', longName: 'YILGARN, SHIRE OF', displayName: 'Shire of Yilgarn' },
      { name: 'YORK', longName: 'YORK, SHIRE OF', displayName: 'Shire of York' },
    ],
  },
  {
    originalDfesRegion: 'GREAT SOUTHERN',
    dfesRegionDisplayName: 'Great Southern',
    lgas: [
      { name: 'ALBANY', longName: 'ALBANY, CITY OF', displayName: 'City of Albany' },
      { name: 'BROOMEHILL-TAMBELLUP', longName: 'BROOMEHILL-TAMBELLUP, SHIRE OF', displayName: 'Shire of Broomehill-Tambellup' },
      { name: 'CRANBROOK', longName: 'CRANBROOK, SHIRE OF', displayName: 'Shire of Cranbrook' },
      { name: 'DENMARK', longName: 'DENMARK, SHIRE OF', displayName: 'Shire of Denmark' },
      { name: 'ESPERANCE', longName: 'ESPERANCE, SHIRE OF', displayName: 'Shire of Esperance' },
      { name: 'GNOWANGERUP', longName: 'GNOWANGERUP, SHIRE OF', displayName: 'Shire of Gnowangerup' },
      { name: 'JERRAMUNGUP', longName: 'JERRAMUNGUP, SHIRE OF', displayName: 'Shire of Jerramungup' },
      { name: 'KATANNING', longName: 'KATANNING, SHIRE OF', displayName: 'Shire of Katanning' },
      { name: 'KOJONUP', longName: 'KOJONUP, SHIRE OF', displayName: 'Shire of Kojonup' },
      { name: 'PLANTAGENET', longName: 'PLANTAGENET, SHIRE OF', displayName: 'Shire of Plantagenet' },
      { name: 'RAVENSTHORPE', longName: 'RAVENSTHORPE, SHIRE OF', displayName: 'Shire of Ravensthorpe' },
    ],
  },
  {
    originalDfesRegion: 'INDIAN OCEAN TERRITORY',
    dfesRegionDisplayName: 'Indian Ocean Territory',
    lgas: [
      { name: 'CHRISTMAS ISLAND', longName: 'CHRISTMAS ISLAND, SHIRE OF', displayName: 'Shire of Christmas Island' },
      { name: 'COCOS ISLANDS', longName: 'COCOS ISLANDS, SHIRE OF', displayName: 'Shire of Cocos Islands' },
    ],
  },
  {
    originalDfesRegion: 'KIMBERLEY',
    dfesRegionDisplayName: 'Kimberley',
    lgas: [
      { name: 'BROOME', longName: 'BROOME, SHIRE OF', displayName: 'Shire of Broome' },
      { name: 'DERBY/WEST KIMBERLEY', longName: 'DERBY/WEST KIMBERLEY, SHIRE OF', displayName: 'Shire of Derby/West Kimberley' },
      { name: 'HALLS CREEK', longName: 'HALLS CREEK, SHIRE OF', displayName: 'Shire of Halls Creek' },
      { name: 'WYNDHAM-EAST KIMBERLEY', longName: 'WYNDHAM-EAST KIMBERLEY, SHIRE OF', displayName: 'Shire of Wyndham-East Kimberley' },
    ],
  },
  {
    originalDfesRegion: 'LOWER SOUTH WEST',
    dfesRegionDisplayName: 'Lower South West',
    lgas: [
      { name: 'BUSSELTON', longName: 'BUSSELTON, CITY OF', displayName: 'City of Busselton' },
      { name: 'AUGUSTA MARGARET RIVER', longName: 'AUGUSTA MARGARET RIVER, SHIRE OF', displayName: 'Shire of Augusta Margaret River' },
      { name: 'BOYUP BROOK', longName: 'BOYUP BROOK, SHIRE OF', displayName: 'Shire of Boyup Brook' },
      { name: 'BRIDGETOWN-GREENBUSHES', longName: 'BRIDGETOWN-GREENBUSHES, SHIRE OF', displayName: 'Shire of Bridgetown-Greenbushes' },
      { name: 'DONNYBROOK-BALINGUP', longName: 'DONNYBROOK-BALINGUP, SHIRE OF', displayName: 'Shire of Donnybrook-Balingup' },
      { name: 'MANJIMUP', longName: 'MANJIMUP, SHIRE OF', displayName: 'Shire of Manjimup' },
      { name: 'NANNUP', longName: 'NANNUP, SHIRE OF', displayName: 'Shire of Nannup' },
    ],
  },
  {
    originalDfesRegion: 'METRO CENTRAL',
    dfesRegionDisplayName: 'Metro Central',
    lgas: [
      { name: 'PERTH', longName: 'PERTH, CITY OF', displayName: 'City of Perth' },
      { name: 'VINCENT', longName: 'VINCENT, CITY OF', displayName: 'City of Vincent' },
    ],
  },
  {
    originalDfesRegion: 'METRO NORTH COASTAL',
    dfesRegionDisplayName: 'Metro North Coastal',
    lgas: [
      { name: 'JOONDALUP', longName: 'JOONDALUP, CITY OF', displayName: 'City of Joondalup' },
      { name: 'NEDLANDS', longName: 'NEDLANDS, CITY OF', displayName: 'City of Nedlands' },
      { name: 'STIRLING', longName: 'STIRLING, CITY OF', displayName: 'City of Stirling' },
      { name: 'SUBIACO', longName: 'SUBIACO, CITY OF', displayName: 'City of Subiaco' },
      { name: 'WANNEROO', longName: 'WANNEROO, CITY OF', displayName: 'City of Wanneroo' },
      { name: 'GINGIN', longName: 'GINGIN, SHIRE OF', displayName: 'Shire of Gingin' },
      { name: 'PEPPERMINT GROVE', longName: 'PEPPERMINT GROVE, SHIRE OF', displayName: 'Shire of Peppermint Grove' },
      { name: 'CAMBRIDGE', longName: 'CAMBRIDGE, TOWN OF', displayName: 'Town of Cambridge' },
      { name: 'CLAREMONT', longName: 'CLAREMONT, TOWN OF', displayName: 'Town of Claremont' },
      { name: 'COTTESLOE', longName: 'COTTESLOE, TOWN OF', displayName: 'Town of Cottesloe' },
      { name: 'MOSMAN PARK', longName: 'MOSMAN PARK, TOWN OF', displayName: 'Town of Mosman Park' },
    ],
  },
  {
    originalDfesRegion: 'METRO NORTH EAST',
    dfesRegionDisplayName: 'Metro North East',
    lgas: [
      { name: 'BAYSWATER', longName: 'BAYSWATER, CITY OF', displayName: 'City of Bayswater' },
      { name: 'BELMONT', longName: 'BELMONT, CITY OF', displayName: 'City of Belmont' },
      { name: 'SWAN', longName: 'SWAN, CITY OF', displayName: 'City of Swan' },
      { name: 'CHITTERING', longName: 'CHITTERING, SHIRE OF', displayName: 'Shire of Chittering' },
      { name: 'MUNDARING', longName: 'MUNDARING, SHIRE OF', displayName: 'Shire of Mundaring' },
      { name: 'BASSENDEAN', longName: 'BASSENDEAN, TOWN OF', displayName: 'Town of Bassendean' },
    ],
  },
  {
    originalDfesRegion: 'METRO SOUTH COASTAL',
    dfesRegionDisplayName: 'Metro South Coastal',
    lgas: [
      { name: 'COCKBURN', longName: 'COCKBURN, CITY OF', displayName: 'City of Cockburn' },
      { name: 'FREMANTLE', longName: 'FREMANTLE, CITY OF', displayName: 'City of Fremantle' },
      { name: 'KWINANA', longName: 'KWINANA, CITY OF', displayName: 'City of Kwinana' },
      { name: 'MANDURAH', longName: 'MANDURAH, CITY OF', displayName: 'City of Mandurah' },
      { name: 'MELVILLE', longName: 'MELVILLE, CITY OF', displayName: 'City of Melville' },
      { name: 'ROCKINGHAM', longName: 'ROCKINGHAM, CITY OF', displayName: 'City of Rockingham' },
      { name: 'EAST FREMANTLE', longName: 'EAST FREMANTLE, TOWN OF', displayName: 'Town of East Fremantle' },
    ],
  },
  {
    originalDfesRegion: 'METRO SOUTH EAST',
    dfesRegionDisplayName: 'Metro South East',
    lgas: [
      { name: 'ARMADALE', longName: 'ARMADALE, CITY OF', displayName: 'City of Armadale' },
      { name: 'CANNING', longName: 'CANNING, CITY OF', displayName: 'City of Canning' },
      { name: 'GOSNELLS', longName: 'GOSNELLS, CITY OF', displayName: 'City of Gosnells' },
      { name: 'KALAMUNDA', longName: 'KALAMUNDA, CITY OF', displayName: 'City of Kalamunda' },
      { name: 'SOUTH PERTH', longName: 'SOUTH PERTH, CITY OF', displayName: 'City of South Perth' },
      { name: 'SERPENTINE-JARRAHDALE', longName: 'SERPENTINE-JARRAHDALE, SHIRE OF', displayName: 'Shire of Serpentine-Jarrahdale' },
      { name: 'VICTORIA PARK', longName: 'VICTORIA PARK, TOWN OF', displayName: 'Town of Victoria Park' },
    ],
  },
  {
    originalDfesRegion: 'MIDWEST/GASCOYNE',
    dfesRegionDisplayName: 'Midwest Gascoyne',
    lgas: [
      { name: 'GREATER GERALDTON', longName: 'GREATER GERALDTON, CITY OF', displayName: 'City of Greater Geraldton' },
      { name: 'CARNAMAH', longName: 'CARNAMAH, SHIRE OF', displayName: 'Shire of Carnamah' },
      { name: 'CARNARVON', longName: 'CARNARVON, SHIRE OF', displayName: 'Shire of Carnarvon' },
      { name: 'CHAPMAN VALLEY', longName: 'CHAPMAN VALLEY, SHIRE OF', displayName: 'Shire of Chapman Valley' },
      { name: 'COOROW', longName: 'COOROW, SHIRE OF', displayName: 'Shire of Coorow' },
      { name: 'CUE', longName: 'CUE, SHIRE OF', displayName: 'Shire of Cue' },
      { name: 'DANDARAGAN', longName: 'DANDARAGAN, SHIRE OF', displayName: 'Shire of Dandaragan' },
      { name: 'IRWIN', longName: 'IRWIN, SHIRE OF', displayName: 'Shire of Irwin' },
      { name: 'MEEKATHARRA', longName: 'MEEKATHARRA, SHIRE OF', displayName: 'Shire of Meekatharra' },
      { name: 'MINGENEW', longName: 'MINGENEW, SHIRE OF', displayName: 'Shire of Mingenew' },
      { name: 'MOORA', longName: 'MOORA, SHIRE OF', displayName: 'Shire of Moora' },
      { name: 'MORAWA', longName: 'MORAWA, SHIRE OF', displayName: 'Shire of Morawa' },
      { name: 'MOUNT MAGNET', longName: 'MOUNT MAGNET, SHIRE OF', displayName: 'Shire of Mount Magnet' },
      { name: 'MURCHISON', longName: 'MURCHISON, SHIRE OF', displayName: 'Shire of Murchison' },
      { name: 'NORTHAMPTON', longName: 'NORTHAMPTON, SHIRE OF', displayName: 'Shire of Northampton' },
      { name: 'PERENJORI', longName: 'PERENJORI, SHIRE OF', displayName: 'Shire of Perenjori' },
      { name: 'SANDSTONE', longName: 'SANDSTONE, SHIRE OF', displayName: 'Shire of Sandstone' },
      { name: 'SHARK BAY', longName: 'SHARK BAY, SHIRE OF', displayName: 'Shire of Shark Bay' },
      { name: 'THREE SPRINGS', longName: 'THREE SPRINGS, SHIRE OF', displayName: 'Shire of Three Springs' },
      { name: 'UPPER GASCOYNE', longName: 'UPPER GASCOYNE, SHIRE OF', displayName: 'Shire of Upper Gascoyne' },
      { name: 'VICTORIA PLAINS', longName: 'VICTORIA PLAINS, SHIRE OF', displayName: 'Shire of Victoria Plains' },
      { name: 'WILUNA', longName: 'WILUNA, SHIRE OF', displayName: 'Shire of Wiluna' },
      { name: 'YALGOO', longName: 'YALGOO, SHIRE OF', displayName: 'Shire of Yalgoo' },
    ],
  },
  {
    originalDfesRegion: 'PILBARA',
    dfesRegionDisplayName: 'Pilbara',
    lgas: [
      { name: 'KARRATHA', longName: 'KARRATHA, CITY OF', displayName: 'City of Karratha' },
      { name: 'ASHBURTON', longName: 'ASHBURTON, SHIRE OF', displayName: 'Shire of Ashburton' },
      { name: 'EAST PILBARA', longName: 'EAST PILBARA, SHIRE OF', displayName: 'Shire of East Pilbara' },
      { name: 'EXMOUTH', longName: 'EXMOUTH, SHIRE OF', displayName: 'Shire of Exmouth' },
      { name: 'PORT HEDLAND', longName: 'PORT HEDLAND, TOWN OF', displayName: 'Town of Port Hedland' },
    ],
  },
  {
    originalDfesRegion: 'SOUTH WEST',
    dfesRegionDisplayName: 'South West',
    lgas: [
      { name: 'BUNBURY', longName: 'BUNBURY, CITY OF', displayName: 'City of Bunbury' },
      { name: 'CAPEL', longName: 'CAPEL, SHIRE OF', displayName: 'Shire of Capel' },
      { name: 'COLLIE', longName: 'COLLIE, SHIRE OF', displayName: 'Shire of Collie' },
      { name: 'DARDANUP', longName: 'DARDANUP, SHIRE OF', displayName: 'Shire of Dardanup' },
      { name: 'HARVEY', longName: 'HARVEY, SHIRE OF', displayName: 'Shire of Harvey' },
      { name: 'MURRAY', longName: 'MURRAY, SHIRE OF', displayName: 'Shire of Murray' },
      { name: 'WAROONA', longName: 'WAROONA, SHIRE OF', displayName: 'Shire of Waroona' },
    ],
  },
  {
    originalDfesRegion: 'UPPER GREAT SOUTHERN',
    dfesRegionDisplayName: 'Upper Great Southern',
    lgas: [
      { name: 'BODDINGTON', longName: 'BODDINGTON, SHIRE OF', displayName: 'Shire of Boddington' },
      { name: 'BROOKTON', longName: 'BROOKTON, SHIRE OF', displayName: 'Shire of Brookton' },
      { name: 'CORRIGIN', longName: 'CORRIGIN, SHIRE OF', displayName: 'Shire of Corrigin' },
      { name: 'CUBALLING', longName: 'CUBALLING, SHIRE OF', displayName: 'Shire of Cuballing' },
      { name: 'DUMBLEYUNG', longName: 'DUMBLEYUNG, SHIRE OF', displayName: 'Shire of Dumbleyung' },
      { name: 'KENT', longName: 'KENT, SHIRE OF', displayName: 'Shire of Kent' },
      { name: 'KONDININ', longName: 'KONDININ, SHIRE OF', displayName: 'Shire of Kondinin' },
      { name: 'KULIN', longName: 'KULIN, SHIRE OF', displayName: 'Shire of Kulin' },
      { name: 'LAKE GRACE', longName: 'LAKE GRACE, SHIRE OF', displayName: 'Shire of Lake Grace' },
      { name: 'NARROGIN', longName: 'NARROGIN, SHIRE OF', displayName: 'Shire of Narrogin' },
      { name: 'PINGELLY', longName: 'PINGELLY, SHIRE OF', displayName: 'Shire of Pingelly' },
      { name: 'WAGIN', longName: 'WAGIN, SHIRE OF', displayName: 'Shire of Wagin' },
      { name: 'WANDERING', longName: 'WANDERING, SHIRE OF', displayName: 'Shire of Wandering' },
      { name: 'WEST ARTHUR', longName: 'WEST ARTHUR, SHIRE OF', displayName: 'Shire of West Arthur' },
      { name: 'WICKEPIN', longName: 'WICKEPIN, SHIRE OF', displayName: 'Shire of Wickepin' },
      { name: 'WILLIAMS', longName: 'WILLIAMS, SHIRE OF', displayName: 'Shire of Williams' },
      { name: 'WOODANILLING', longName: 'WOODANILLING, SHIRE OF', displayName: 'Shire of Woodanilling' },
    ],
  },
];

export const lgasNameMapping = new Map(
  regionsLgasMapping.flatMap((region: DfesRegion) => region.lgas.map((lga) => [lga.longName, lga.displayName]))
);

export const lgaRegionMapping = new Map(
  regionsLgasMapping.flatMap((region) => region.lgas.map((lga) => [lga.longName, region.originalDfesRegion]))
);
